export enum BankTransferType {
    None = 0,
    CardNumberClabe = 1,
    CardNumber,
    Clabe,
    AccountNumber,
    CardNumberAccountNumberClabe
}
  